import { useMemo } from "react";
import useSWR from "swr";

import { PROFILE_PARAM } from "@/consts";
import { getJSON } from "@/utils/swr";

const API_URL = `${import.meta.env.VITE_API_HOST}/api/bookings/csrf`;

const useCsrfToken = () => {
  const profileParam = useMemo(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const profile = searchParams.get(PROFILE_PARAM);
    return profile ? `?profile=${profile}` : "";
  }, []);

  useSWR(
    `${API_URL}${profileParam}`,
    getJSON("", {
      requestOptions: {
        credentials: "include",
      },
    }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
};

export default useCsrfToken;
